<template>
<div class="gm-wrap">
<p class="gm-status" v-if="coordinatesLoading">Loading coordinates...</p>
<gmap-map :center="centercoordinate" :zoom="16" class="gm-map" v-if="!coordinatesLoading && hasCoordinate">
	<gmap-polyline :options="{'strokeColor': '#FF0000'}" :path="mappedPath"></gmap-polyline>
   <gmap-info-window :options="infoOptions" :position="infoWindowPos" :opened="infoWinOpen" @closeclick="infoWinOpen=false">
        {{ infoContent }}
    </gmap-info-window>
  <gmap-marker
    :key="index"
    v-for="(m, index) in markerPath"
    :position="m.coor"
    :clickable="true"
    :draggable="true"
    :icon="m.icon"
    @mouseover= "toggleInfoWindow(m,index)"
  ></gmap-marker>
</gmap-map>
<div class="gm-empty-shell" v-if="!coordinatesLoading && !hasCoordinate">
  <section class="gm-empty-card">
    <div class="gm-empty-header">
      <div class="gm-icon-pill">
        <svg class="gm-icon" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path d="M12 21s7-5.1 7-11a7 7 0 0 0-14 0c0 5.9 7 11 7 11z"></path>
          <circle cx="12" cy="10" r="2.5"></circle>
        </svg>
      </div>
      <div>
        <h1 class="gm-empty-title">No coordinates found</h1>
        <p class="gm-empty-subtitle">The API checked the available location sources for this runner.</p>
      </div>
    </div>

    <div class="gm-meta-grid">
      <div class="gm-meta-item">
        <span class="gm-meta-label">Race</span>
        <strong class="gm-meta-value">{{ raceId }}</strong>
      </div>
      <div class="gm-meta-item">
        <span class="gm-meta-label">Runner</span>
        <strong class="gm-meta-value">{{ runnerId }}</strong>
      </div>
      <div class="gm-meta-item">
        <span class="gm-meta-label">Source</span>
        <strong class="gm-meta-value">{{ diagnosticSource }}</strong>
      </div>
    </div>

    <div class="gm-detail-list" v-if="diagnosticDetails.length">
      <div class="gm-detail-row" v-for="(item, index) in diagnosticDetails" :key="index">
        <span class="gm-detail-dot" :class="'gm-detail-dot--' + item.status"></span>
        <div class="gm-detail-copy">
          <strong class="gm-detail-title">{{ item.title }}</strong>
          <p class="gm-detail-text">{{ item.message }}</p>
        </div>
        <span class="gm-detail-count" v-if="item.count !== null">{{ item.count }}</span>
      </div>
    </div>
  </section>
</div>
</div>

</template>

<script>
  import LocationService from '../../../services/locationService'

  export default {
    name: 'google-map',
    props: ['runnerId', 'raceId'],
    data: () => ({
    mappedPath:[],
    markerPath:[],
    customArray:[],
    centercoordinate:{},
    hasCoordinate:false,
    coordinatesLoading:true,
    diagnosticDetails: [],
    diagnosticSource: 'None',
    infoContent: '',
    infoWindowPos: null,
    infoWinOpen: false,
    currentMidx: null,
    infoOptions: {
          pixelOffset: {
            width: 0,
            height: -35
          }
        },
    icon2: {
              url: "http://maps.google.com/mapfiles/ms/icons/green-dot.png",
              size: { width: 46, height: 46, f: "px", b: "px" },
              scaledSize: { width: 46, height: 46, f: "px", b: "px" }
          },
    icon3: {
        url: "http://maps.google.com/mapfiles/ms/icons/blue-dot.png",
        size: { width: 46, height: 46, f: "px", b: "px" },
        scaledSize: { width: 46, height: 46, f: "px", b: "px" }
        },
    }),

    methods: {
     addMarkers(){
          this.markerPath = []
          if (!this.customArray.length) {
            return
          }

          for (var i = 0; i < this.customArray.length; i+= 3) {
            this.customArray[i]['icon'] = i === 0 ? this.icon2 : null
            this.markerPath.push(this.customArray[i])
          }

          var index = this.customArray.length-1
          this.customArray[index]['icon'] = this.icon3
          if (index === 0) {
            this.markerPath[0] = this.customArray[index]
          } else {
            this.markerPath.unshift(this.customArray[index])
          }
     },
     toggleInfoWindow: function(marker, idx) {
       console.log("marker--",marker)
        this.infoWindowPos = marker.coor
            this.infoContent = marker.time

            //check if its the same marker that was selected if yes toggle
            if (this.currentMidx == idx) {
              this.infoWinOpen = !this.infoWinOpen
            }
            //if different marker set infowindow to open and reset current marker index
            else {
              this.infoWinOpen = true
              this.currentMidx = idx

            }
     },
     applyCoordinates(coordinates) {
          var previousDis = 0
          var totalDis = 0
          this.mappedPath = []
          this.customArray = []
          this.markerPath = []

          coordinates.forEach((coordinate) => {
            var distance = coordinate.distance || 0
            var diff = distance - previousDis
            totalDis = totalDis + diff
            previousDis = distance

            var point = {lat: coordinate.latitude, lng: coordinate.longitude}
            this.mappedPath.push(point)
            this.customArray.push({
              time: coordinate.timestamp,
              coor: point,
              distance: coordinate.distance
            })
          })

          this.hasCoordinate = this.mappedPath.length > 0
          if (this.hasCoordinate) {
            this.centercoordinate = this.mappedPath[0]
            this.addMarkers()
          }
          console.log("distance total---",totalDis.toFixed(2))
     },
     formatDetail(detail) {
          if (!Array.isArray(detail)) {
            return []
          }

          return detail.map((item) => {
            if (typeof item === 'string') {
              return {
                title: item,
                message: item,
                status: 'complete',
                count: null
              }
            }

            var source = item.source ? item.source.charAt(0).toUpperCase() + item.source.slice(1) : 'Result'
            var status = item.status || 'complete'
            return {
              title: source + ' - ' + status,
              message: item.message || item.step || 'Diagnostic step completed',
              status: status,
              count: item.count !== undefined ? item.count : null
            }
          })
     },
     applyDiagnostics(payload, responseDetail) {
          var detail = payload && payload.detail ? payload.detail : responseDetail
          this.diagnosticDetails = this.formatDetail(detail)
          this.diagnosticSource = payload && payload.source ? payload.source : 'None'
     },
     async loadCoordinates() {
          this.coordinatesLoading = true
          try {
            const response = await LocationService.getRunnerCoordinates(this.$props.raceId, this.$props.runnerId)
            const payload = response.data && response.data.data ? response.data.data : {}
            const coordinates = payload.coordinates
              ? payload.coordinates
              : []
            this.applyDiagnostics(payload, response.data ? response.data.detail : [])
            this.applyCoordinates(coordinates)
          } catch (error) {
            console.error('Failed to load runner coordinates', error)
            const responseData = error.response && error.response.data ? error.response.data : {}
            this.diagnosticDetails = this.formatDetail(responseData.detail || [{
              source: 'api',
              status: 'error',
              message: responseData.message || 'The coordinate lookup request failed before diagnostics were returned',
              count: 0
            }])
            this.diagnosticSource = 'Error'
            this.hasCoordinate = false
          } finally {
            this.coordinatesLoading = false
          }
     },

    },

    created() {
      this.loadCoordinates()
    },
  
    components: {

    }
  }
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;600;700;900&display=swap');
</style>

<style scoped>
.gm-wrap {
  min-height: 768px;
}

.gm-map {
  width: 1535px;
  height: 768px;
}

.gm-status {
  color: #8a8a9a;
  font-size: 13px;
  margin: 1rem 0;
}

.gm-empty-shell {
  align-items: center;
  display: flex;
  justify-content: center;
  min-height: 768px;
  padding: 2rem;
}

.gm-empty-card {
  background: #fff;
  border: 1px solid #e8e8ed;
  border-radius: 14px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.05);
  max-width: 620px;
  padding: 1.5rem 1.75rem;
  width: 100%;
}

.gm-empty-header {
  align-items: center;
  border-bottom: 1px solid #f0f0f5;
  display: flex;
  gap: 12px;
  padding-bottom: 1rem;
}

.gm-icon-pill {
  align-items: center;
  background: #f0effe;
  border-radius: 10px;
  color: #5b4fcf;
  display: flex;
  flex: 0 0 36px;
  height: 36px;
  justify-content: center;
  width: 36px;
}

.gm-icon {
  height: 18px;
  stroke: currentColor;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1.8;
  width: 18px;
}

.gm-empty-title {
  color: #1a1a2e;
  font-family: 'Inter', sans-serif;
  font-size: 20px;
  font-weight: 900;
  letter-spacing: 0;
  line-height: 1.1;
  margin: 0;
}

.gm-empty-subtitle {
  color: #8a8a9a;
  font-size: 13px;
  font-weight: 400;
  margin: 5px 0 0;
}

.gm-meta-grid {
  display: grid;
  gap: 10px;
  grid-template-columns: repeat(3, 1fr);
  margin-top: 1rem;
}

.gm-meta-item {
  background: #fafafa;
  border: 1px solid #e8e8ed;
  border-radius: 8px;
  padding: 0.75rem;
}

.gm-meta-label {
  color: #8a8a9a;
  display: block;
  font-size: 11px;
  font-weight: 600;
  margin-bottom: 4px;
}

.gm-meta-value {
  color: #1a1a2e;
  display: block;
  font-size: 13px;
  font-weight: 700;
}

.gm-detail-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 1rem;
}

.gm-detail-row {
  align-items: center;
  background: #fafafa;
  border: 1px solid #e8e8ed;
  border-radius: 8px;
  display: flex;
  gap: 10px;
  padding: 0.8rem;
}

.gm-detail-dot {
  background: #8a8a9a;
  border-radius: 50%;
  flex: 0 0 8px;
  height: 8px;
  width: 8px;
}

.gm-detail-dot--found,
.gm-detail-dot--complete {
  background: #5b4fcf;
}

.gm-detail-dot--empty {
  background: #c7c7d4;
}

.gm-detail-dot--error {
  background: #c0392b;
}

.gm-detail-copy {
  flex: 1;
}

.gm-detail-title {
  color: #1a1a2e;
  display: block;
  font-size: 12px;
  font-weight: 700;
}

.gm-detail-text {
  color: #8a8a9a;
  font-size: 12px;
  margin: 3px 0 0;
}

.gm-detail-count {
  align-items: center;
  background: #f0effe;
  border-radius: 999px;
  color: #5b4fcf;
  display: inline-flex;
  font-size: 12px;
  font-weight: 700;
  height: 24px;
  justify-content: center;
  min-width: 32px;
  padding: 0 8px;
}

@media (max-width: 640px) {
  .gm-meta-grid {
    grid-template-columns: 1fr;
  }
}
</style>



// WEBPACK FOOTER //
// GoogleMap.vue?adc86698